export default "__VITE_ASSET__DT1U6YJJ__"